import { UriFilter } from '../models/filter';

export function getUriFilterValueByName(uriFilters: UriFilter[], name: string) {
  return uriFilters.find((uriFilter) => uriFilter.name === name)?.uri;
}
